import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '~services/auth/auth.service';
import { FeatureFlagService } from '~services/feature-flag/feature-flag.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    private authService: AuthService,
    private readonly featureFlagService: FeatureFlagService,
    private readonly router: Router,
  ) {}

  async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.featureFlagService.isV2Enabled) return true;

    if (!this.authService.isAuthenticated()) {
      this.authService.navigateToLoginPage(state.url);
      return false;
    }

    return true;
  }
}
